import { Browser } from "@capacitor/browser";

import { isNativeMobileApp } from "../platform.helpers";
import { isUnsafeUrl } from "../validators";

const URL_SCHEME_PATTERN = /^([a-z][a-z0-9+.-]*):/;

/**
 * Opens a URL using Browser.open for http/https/relative URLs, or window.open for other protocols.
 */
export const openUrl = (url: string): void => {
  if (!url) {
    return;
  }

  const trimmed = url.trim();

  if (!trimmed) {
    return;
  }

  if (isUnsafeUrl(trimmed)) {
    return;
  }

  const lower = trimmed.toLowerCase();
  const match = URL_SCHEME_PATTERN.exec(lower);
  const scheme = match?.[1];

  if (isNativeMobileApp() && (!scheme || scheme === "http" || scheme === "https")) {
    Browser.open({ url: trimmed });
  } else if (scheme === "http" || scheme === "https") {
    // Absolute web URLs can point at third-party sites we don't control (e.g. a practice's
    // own website). Without noopener the opened page keeps a handle on window.opener and can
    // navigate this tab out from under the user — reverse tabnabbing. Scoped to http(s) so
    // tel:/mailto:/sms:/custom-scheme handoffs keep their existing behavior, and relative
    // URLs (same-origin) are unaffected.
    window.open(trimmed, "_blank", "noopener,noreferrer");
  } else {
    window.open(trimmed);
  }
};
